module.exports = __webpack_public_path__ + "static/media/web.3f08e6f9.svg";